import { ControlProps, TextInput, TextInputProps } from 'lego-on-react';
import React, { memo, useCallback, useEffect, useState } from 'react';

import { hasSpecialChars } from 'client/utils/settings/common';
import debounce from 'lodash/debounce';

export const TextInputEnhanced = memo(function TexInputDebounced(
    props: Readonly<TextInputProps & ControlProps & { wait?: number; escapeSpecialChars?: boolean }>,
) {
    const { escapeSpecialChars, text, onChange, wait = 500 } = props;
    const [inputValue, setInputValue] = useState<string | undefined>();
    useEffect(() => {
        setInputValue(String(text));
    }, [text]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onChangeDebounced = useCallback(debounce(onChange || (() => {}), wait), [onChange]);
    const onInputChange = (updatedValue: string) => {
        if (escapeSpecialChars && hasSpecialChars(updatedValue)) return;
        setInputValue(updatedValue);
        onChangeDebounced(updatedValue);
    };

    return <TextInput {...props} text={inputValue} onChange={onInputChange} />;
});
